import { Divider, makeStyles, Theme, Typography, TypographyProps } from '@material-ui/core';
import React, { ReactNode } from 'react';

export type DrawerTitleProps = {
  title?: string;
  children?: ReactNode;
  className?: string;
  titleProps?: TypographyProps;
  caption?: ReactNode;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3.5, 4, 3.5, 4),
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  caption: {
    padding: theme.spacing(0, 4, 0, 0),
  },
}));

export const DrawerTitle = ({
  title,
  children,
  className,
  titleProps,
  caption,
  ...props
}: DrawerTitleProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={className} {...props}>
      <div className={classes.titleWrapper}>
        <Typography
          id="drawer-title"
          data-testid={`drawer-title-${title?.replace(/[\s/]+/g, '-').toLocaleLowerCase()}`}
          variant="h1"
          className={classes.root}
          {...titleProps}
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          id="drawer-caption"
          data-testid={`drawer-caption-${title?.replace(/[\s/]+/g, '-').toLocaleLowerCase()}`}
          className={classes.caption}
        >
          {caption}
        </Typography>
      </div>
      <Divider />
      {children}
    </div>
  );
};

export default DrawerTitle;
